import {get, filter} from 'lodash'

export default {
  methods: {
    clearLabels () {
      this.getAllLabels()
    },
    getAllLabels () {
      this.$gapi.request({
        path: 'https://www.googleapis.com/gmail/v1/users/me/labels/',
        method: 'GET'
      })
        .then(resp => {
          const labels = get(resp, 'result.labels', [])
          const userLabels = filter(labels, label => {
            const labelName = label.name.includes('Label')
            const labelId = label.name.includes('Label')
            const isDefault = labelName && labelId
            const userType = label.type === 'user'
            return userType && isDefault
          })
          this.getInfoLabels(userLabels)
        })
        .catch(err => {
          console.error(err)
        })
    },
    async getInfoLabels (labels) {
      const promisesThreads = labels.map(async label => {
        label = await this.getLabel(label.id)
        return label
      })
      const result = await Promise.all(promisesThreads)
      result.forEach(label => {
        if (label.messagesTotal === 0) this.deleteLabel(label.id)
      })
    },
    async getLabel (labelId) {
      try {
        const resp = await this.$gapi.request({
          path: `https://www.googleapis.com/gmail/v1/users/me/labels/${labelId}`,
          method: 'GET'
        })
        return resp.result
      } catch (err) {
        console.error(err)
        return {}
      }
    },
    deleteLabel (labelId) {
      if (!labelId) return
      this.$gapi.request({
        path: `https://www.googleapis.com/gmail/v1/users/me/labels/${labelId}`,
        method: 'DELETE'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/clearLabels.js